import { render, staticRenderFns } from "./AwaitingApproval.vue?vue&type=template&id=061ab08e&"
import script from "./AwaitingApproval.vue?vue&type=script&lang=js&"
export * from "./AwaitingApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports